import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import {
  Layout,
  SEO,
  RenderSections,
  Header,
  Footer,
} from "src/components/common"

import { ZebraBlogs } from "src/components/blog"

import { useMeta } from "src/utils"

const Home = props => {
  const { blog } = useStaticQuery(QUERY)

  const meta = useMeta({ ...blog })

  const components = {
    zebraBlogs: {
      component: ZebraBlogs,
    },
    blogPostBottomCTA: {
      component: () => <span></span>, // placehlder is required for each section...
    },
  }

  return (
    <>
      <SEO {...meta} />
      <Layout pageContext={props.pageContext}>
        <Header />
        <RenderSections sections={blog.sections} components={components} />
        <Footer />
      </Layout>
    </>
  )
}

const QUERY = graphql`
  {
    blog: contentfulPage(pageId: { eq: "blog" }) {
      ...Page
    }
  }
`

export default Home
